
import React from 'react';
import Layout from '@/components/Layout/Layout';
import PercentageCalculator from '@/components/SpecialCalculators/PercentageCalculator';
import { Link } from 'react-router-dom';

const PercentageCalculatorPage = () => {
  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-4">
        {/* Header Section */}
        <div className="mb-8">
          <div className="text-sm text-gray-500 mb-2">
            <Link to="/" className="hover:underline">Home</Link> {' > '} 
            <Link to="/special" className="hover:underline">Special Tools</Link> {' > '} 
            <span>Percentage Calculator</span>
          </div>
          <h1 className="text-3xl font-bold mb-3">Percentage Calculator</h1>
          <p className="text-gray-700">
            Calculate percentages, percentage changes, and determine what percent one number is of another.
          </p>
        </div>

        {/* Calculator Section */}
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 mb-8">
          <PercentageCalculator />
        </div>

        {/* Information Section */}
        <div className="bg-[#E6F3FF] p-6 rounded-lg mb-8">
          <h2 className="text-2xl font-semibold mb-3">How to use the Percentage Calculator</h2>
          <p className="mb-4">This calculator offers three different percentage calculations:</p>
          <ol className="list-decimal list-inside space-y-2 text-gray-700 ml-2">
            <li><strong>Basic Percentage:</strong> Calculate a percentage of a number (e.g., 10% of 100)</li>
            <li><strong>Percentage Change:</strong> Calculate the percentage increase or decrease between two values</li>
            <li><strong>Percent of Value:</strong> Determine what percentage one number is of another</li>
          </ol>
        </div>

        {/* Additional Information */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">About Percentages</h2>
          <p className="text-gray-700 mb-3">
            A percentage is a number expressed as a fraction of 100. It is often denoted using the percent sign, "%".
            For example, 45% (read as "forty-five percent") is equal to 45/100, or 0.45.
          </p>
          <p className="text-gray-700 mb-3">
            Percentage calculations are common in many areas, including finance (interest rates, discounts),
            statistics, academic grading, and many everyday situations like calculating tips or sales tax.
          </p>
          <h3 className="text-xl font-medium mb-2">Common Percentage Formulas</h3>
          <ul className="list-disc list-inside space-y-2 text-gray-700 ml-2">
            <li><strong>Finding a percentage of a value:</strong> (Value × Percentage) ÷ 100</li>
            <li><strong>Calculating percentage change:</strong> ((New Value - Original Value) ÷ Original Value) × 100</li>
            <li><strong>Finding what percent X is of Y:</strong> (X ÷ Y) × 100</li>
          </ul>
        </div>

        {/* Related Calculators */}
        <div className="mb-8">
          <h2 className="text-2xl font-semibold mb-3">Related Calculators</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            <Link to="/special/tip" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">🍽️</span> Tip Calculator
            </Link>
            <Link to="/special/mortgage" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">🏠</span> Mortgage Calculator
            </Link>
            <Link to="/special/loan" className="p-4 border border-gray-200 rounded-md hover:bg-gray-50 flex items-center">
              <span className="text-xl mr-2">💰</span> Loan Calculator
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PercentageCalculatorPage;
